import axios from 'axios';
import Vue from 'vue';
import * as constants from '../constants';

export default {
  namespaced: true,

  state: {
    data: [],
    tva: [{id: '0.00', name: '0%'}, {id: '9.00', name: '9%'}, {id: '19.00', name: '19%'}]
  },

  actions: {
    LOAD({ commit }, { filter }) {
      let params = {};
      let download = false;
      if (filter) {
        for (let key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;

        download = filter.hasOwnProperty('_download_');
        if (download) {
          params.rowsPerPage = -1;
        }
      }
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/products`, {
          params: params,
          responseType: download ? 'arraybuffer' : 'json'
        })
          .then(response => response.data)
          .then(response => {
            if (!download) {
              commit('PRODUCTS', response.data);
            }
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    LOAD_ONE({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/products/${id}`)
          .then(response => response.data)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/products/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/products/${data.id}`, data)
          .then(response => {
            commit('EDIT', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${constants.SERVER_URL}/api/products/`, data)
          .then(response => {
            commit('ADD', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }
  },

  mutations: {
    PRODUCTS(state, payload) {
      state.data = payload;
    },

    EDIT(state, payload) {
      const index = state.data.findIndex(product => product.id === payload.id);
      if (index > -1) {
        Vue.set(state.data, index, payload);
      }
    },

    ADD(state, payload) {
      state.data.unshift(payload);
    },

    DELETE(state, id) {
      const index = state.data.findIndex(item => item.id === id);
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {

  }
};



// WEBPACK FOOTER //
// ./src/store/products.js